import { Transform, CSS } from '@dnd-kit/utilities';

interface SortableStyleOptions {
  transform: Transform | null;
  transition?: string;
  isDragging?: boolean;
  isDragOverlay?: boolean;
  additionalStyles?: React.CSSProperties;
}

/**
 * Common style generator for sortable elements
 * @param options - Style options including transform, transition, and drag states
 * @returns CSS properties object
 */
export const getSortableStyle = ({
  transform,
  transition,
  isDragging = false,
  isDragOverlay = false,
  additionalStyles = {},
}: SortableStyleOptions): React.CSSProperties => {
  const baseStyles: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.3 : isDragOverlay ? 1 : 1,
    backgroundColor: isDragOverlay ? '#fff' : '',
  };

  return {
    ...baseStyles,
    ...additionalStyles,
  };
};
